import { render, staticRenderFns } from "./CaseStudyCard.vue?vue&type=template&id=5ae541d8&scoped=true&"
import script from "./CaseStudyCard.vue?vue&type=script&lang=js&"
export * from "./CaseStudyCard.vue?vue&type=script&lang=js&"
import style0 from "./CaseStudyCard.vue?vue&type=style&index=0&id=5ae541d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae541d8",
  null
  
)

export default component.exports